import React from 'react'
import { useTranslation } from 'react-i18next'
import CopyButton from '../components/CopyButton';
import NextSectionCard from '../components/NextSectionCard';
import { timeSince } from '../utils/timeSince';
import PreviousSectionCard from '../components/PreviousSectionCard';
import downloadIcon from "../assets/icons/download.svg";
import { Trans } from "react-i18next";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import gopaperlessAgentInstaller from "../assets/image/installationGopaperlessAgent/gopaperlessAgentInstaller.png";
import setup from "../assets/image/installationGopaperlessAgent/setup.png";
import license from "../assets/image/installationGopaperlessAgent/license.png";
import installlicense from "../assets/image/installationGopaperlessAgent/installlicense.png";
import installing from "../assets/image/installationGopaperlessAgent/installing.png";
import complete from "../assets/image/installationGopaperlessAgent/complete.png";
import client from "../assets/image/installationGopaperlessAgent/client.png";

const InstallGopaperlessAgent = () => {
    const { t, i18n } = useTranslation();
    const lastUpdated = "2026-03-03";
    const lang = i18n.language;

    const buildCopyText = (t) => {
        const clean = (key) =>
            t(key).replace(/<[^>]+>/g, "").trim();

        return `
${t("sidebar.install.itemInstall")}

${clean("installationGopaperlessAgent.step1")}

${clean("installationGopaperlessAgent.step2")}

${clean("installationGopaperlessAgent.step3")}

${clean("installationGopaperlessAgent.step4")}

${clean("installationGopaperlessAgent.step5")}

${clean("installationGopaperlessAgent.step6")}

${clean("installationGopaperlessAgent.todo")}
- ${clean("installationGopaperlessAgent.todo1")}
- ${clean("installationGopaperlessAgent.todo2")}
- ${clean("installationGopaperlessAgent.todo3")}
- ${clean("installationGopaperlessAgent.note1")}
- ${clean("installationGopaperlessAgent.note2")}

${clean("installationGopaperlessAgent.step7")}

${clean("installationGopaperlessAgent.completeclient")}
    `.trim();
    };
    return (
        <div className="text-black dark:text-white">
            <div
                className="
          desktop:px-4
          py-3
          max-w-3xl
        "
            >
                <div className="relative flex items-center justify-between gap-3">
                    <div className="flex items-center gap-1">
                        <div>
                            <img src={downloadIcon} alt="tutorial" className="w-6 h-6" />
                        </div>
                        <div>
                            <p className="text-[16px] tabletpro:text-[14px] mini_mobile:text-[14px] text-[#0087FE] font-normal">
                                {t("sidebar.install.title").toUpperCase()}
                            </p>
                        </div>
                    </div>

                    <CopyButton text={buildCopyText(t)} />
                </div>

                <div className="mt-2 relative">
                    <section className='flex gap-4'>
                        <p className='text-[#020617] dark:text-[#F8FAFC] text-[40px] tabletpro:text-[22px] mobile:text-[30px] mini_mobile:text-[24px] font-semibold'>{t("sidebar.install.itemInstall")}</p>
                    </section>

                    <section className='flex flex-col gap-4 mt-1'>
                        <div className="space-y-2">
                            <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="installationGopaperlessAgent.step1"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </p>

                            <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="installationGopaperlessAgent.step2"
                                    components={{
                                        strong: <span className="font-semibold" />
                                    }}
                                />
                            </p>

                            <Zoom zoomMargin={80} zoomImg={{
                                src: gopaperlessAgentInstaller

                            }}>
                                <img
                                    src={gopaperlessAgentInstaller}
                                    alt="gopaperlessAgentInstaller"
                                    className="max-w-full h-auto cursor-zoom-in mx-auto block"
                                />
                            </Zoom>

                            <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9] whitespace-pre-line">
                                <Trans
                                    i18nKey="installationGopaperlessAgent.step3"
                                    components={{
                                        strong: <span className="font-semibold" />
                                    }}
                                />
                            </p>

                            <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9] whitespace-pre-line">
                                <Trans
                                    i18nKey="installationGopaperlessAgent.step4"
                                    components={{
                                        strong: <span className="font-semibold" />
                                    }}
                                />
                            </p>

                            <Zoom zoomMargin={80} zoomImg={{
                                src: setup
                            }}>
                                <img
                                    src={setup}
                                    alt="setup"
                                    className="max-w-full h-auto cursor-zoom-in mx-auto block"
                                />
                            </Zoom>

                            <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9] whitespace-pre-line">
                                <Trans
                                    i18nKey="installationGopaperlessAgent.step5"
                                    components={{
                                        strong: <span className="font-semibold" />
                                    }}
                                />
                            </p>

                            <Zoom zoomMargin={80} zoomImg={{
                                src: license
                            }}>
                                <img
                                    src={license}
                                    alt="license"
                                    className="max-w-full h-auto cursor-zoom-in mx-auto block"
                                />
                            </Zoom>

                            <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9] whitespace-pre-line">
                                <Trans
                                    i18nKey="installationGopaperlessAgent.step6"
                                    components={{
                                        strong: <span className="font-semibold" />
                                    }}
                                />
                            </p>

                            <Zoom zoomMargin={80} zoomImg={{
                                src: installlicense
                            }}>
                                <img
                                    src={installlicense}
                                    alt="gopaperlessAgentInstaller"
                                    className="max-w-full h-auto cursor-zoom-in mx-auto block"
                                />
                            </Zoom>

                            <p className="text-[16px] font-semibold text-[#0F172A] dark:text-[#F1F5F9] whitespace-pre-line">
                                <Trans
                                    i18nKey="installationGopaperlessAgent.todo"
                                    components={{
                                        strong: <span className="font-semibold" />
                                    }}
                                />
                            </p>

                            <ul className="list-disc pl-6 space-y-1">
                                <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                    {t("installationGopaperlessAgent.todo1")}
                                </li>
                                <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                    {t("installationGopaperlessAgent.todo2")}
                                </li>
                                <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                    {t("installationGopaperlessAgent.todo3")}
                                </li>

                                 <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                    {t("installationGopaperlessAgent.note1")}
                                </li>
                                <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                    {t("installationGopaperlessAgent.note2")}
                                </li>
                            </ul>

                            {/* <p className="text-[16px] font-semibold text-[#0F172A] dark:text-[#F1F5F9] whitespace-pre-line">
                                <Trans
                                    i18nKey="installationGopaperlessAgent.note"
                                    components={{
                                        strong: <span className="font-semibold" />
                                    }}
                                />
                            </p> */}

                            {/* <ul className="list-disc pl-6 space-y-1">
                                <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                    {t("installationGopaperlessAgent.note1")}
                                </li>
                                <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                    {t("installationGopaperlessAgent.note2")}
                                </li>
                            </ul> */}

                            <Zoom zoomMargin={80} zoomImg={{
                                src: installing
                            }}>
                                <img
                                    src={installing}
                                    alt="installing"
                                    className="max-w-full h-auto cursor-zoom-in mx-auto block"
                                />
                            </Zoom>

                            <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9] whitespace-pre-line">
                                <Trans
                                    i18nKey="installationGopaperlessAgent.step7"
                                    components={{
                                        strong: <span className="font-semibold" />
                                    }}
                                />
                            </p>

                            <Zoom zoomMargin={80} zoomImg={{
                                src: complete
                            }}>
                                <img
                                    src={complete}
                                    alt="complete"
                                    className="max-w-full h-auto cursor-zoom-in mx-auto block"
                                />
                            </Zoom>

                            <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9] whitespace-pre-line">
                                <Trans
                                    i18nKey="installationGopaperlessAgent.completeclient"
                                    components={{
                                        strong: <span className="font-semibold" />
                                    }}
                                />
                            </p>

                            <Zoom zoomMargin={80} zoomImg={{
                                src: client
                            }}>
                                <img
                                    src={client}
                                    alt="client"
                                    className="max-w-full h-auto cursor-zoom-in mx-auto block"
                                />
                            </Zoom>
                        </div>
                    </section>

                    <section className='flex gap-4 mt-4 flex-col tabletpro:flex-row desktop:flex-row'>
                        <PreviousSectionCard
                            label={t("sidebar.install.title")}
                            to="/installation"
                        />
                        <NextSectionCard
                            label={t("sidebar.install.itemUninstall")}
                            to="/uninstall-gopaperlessagent"
                        />
                    </section>

                    {/* Last updated */}
                    <section className='flex gap-4 mt-4'>
                        <span className="text-[14px] text-[#64748B]">
                            {t("welcome.lastUpdatedBase")} {timeSince(lastUpdated, lang)}
                        </span>
                    </section>
                </div>

            </div>
        </div>

    )
}

export default InstallGopaperlessAgent
